import {v4 as uuid, v5 as uuidv5} from 'uuid';
import uuidBase62 from "../uuid62";

// Namespace UUID for deterministic generic CaseType IDs (generated once, never changes)
const GENERIC_CASETYPE_NAMESPACE = '7a3f8e2d-1b4c-5d6e-9f0a-2c3b4d5e6f7a';

/**
 * Generate a random UUIDv4 value encoded in Base62.
 *
 * @returns {string} A random UUIDv4 value in Base62
 */
export function genUUIDBase62(): string {
    return uuidBase62.encode(uuid());
}

/**
 * Return a base62 (a-A0-9) encoded string from the source
 * @param {string} uid
 * @returns {string}
 */
export function encodeBase62(uid: string): string {
    return uuidBase62.encode(uid);
}

/**
 * Return a UUID "zero".  This is used in tables to represent a null UUID where the field is required.
 *
 * @returns {string} The "zero" UUID, 00000000-0000-0000-0000-000000000000
 */
export function getZeroUUID(): string {
    return '00000000-0000-0000-0000-000000000000';
}

/**
 * Generate a random UUIDv4 value.
 *
 * @returns {string} A random UUIDv4 value
 */
export function genUUID(): string {
    return uuid();
}

/**
 * Generate a deterministic UUID v5 for a generic category CaseType.
 * Always returns the same UUID for the same firmId + category combination.
 *
 * @param {string} firmId - The firm's UUID
 * @param {string} category - The case type category name
 * @returns {string} A deterministic UUID v5
 */
export function genGenericCaseTypeUUID(firmId: string, category: string): string {
    return uuidv5(`${firmId}:generic:${category}`, GENERIC_CASETYPE_NAMESPACE);
}

